/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Fuehrungzeugnisrelevanteeintraege2Inputs */

const de__field_fuehrungzeugnisrelevanteeintraege2 = /** @type {(inputs: _Field_Fuehrungzeugnisrelevanteeintraege2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liegen relevante Einträge in Führungszeugnis vor`)
};

/**

* @param {_Field_Fuehrungzeugnisrelevanteeintraege2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_fuehrungzeugnisrelevanteeintraege2 = /** @type {((inputs?: _Field_Fuehrungzeugnisrelevanteeintraege2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Fuehrungzeugnisrelevanteeintraege2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_fuehrungzeugnisrelevanteeintraege2(inputs)
});
export { _field_fuehrungzeugnisrelevanteeintraege2 as "_field_fuehrungzeugnisRelevanteEintraege" }